import { RestClient } from '@/api/rest-client'
import { GamificationBadge } from '@/api/model/gamification-badge'

export class GamificationBadgeClient extends RestClient<GamificationBadge> {
    collectionName = 'gamification_badges'
    parseData = GamificationBadge.fromData
}
